import type { UseMutationExecute } from "urql"
import { useMutation } from "urql"

import type {
  ToggleFileArchivedStatusMutation,
  ToggleFileArchivedStatusMutationVariables,
} from "@/graphql/codegen/graphql"
import { ToggleFileArchivedStatusDocument } from "@/graphql/codegen/graphql"

const useToggleFileArchivedStatus = (): {
  isUpdatingStatus: boolean
  toggleFileArchivedStatus: UseMutationExecute<
    ToggleFileArchivedStatusMutation,
    ToggleFileArchivedStatusMutationVariables
  >
} => {
  const [{ fetching: isUpdatingStatus }, toggleFileArchivedStatus] = useMutation<
    ToggleFileArchivedStatusMutation,
    ToggleFileArchivedStatusMutationVariables
  >(ToggleFileArchivedStatusDocument)
  return {
    isUpdatingStatus,
    toggleFileArchivedStatus,
  }
}

export default useToggleFileArchivedStatus
